import RestService from './RestService';

export default class GriService extends RestService {
    constructor() {
        super('/gri');
    }

    metrics() {
        return this.get(`${this.baseUrl}/metrics`);
    }
}
